const enCitiesRegions = {
  Riyadh: [
    "Al Aarid",
    "Almursalat",
    "Al Jazirah",
    "Ar Rahmaniyyah",
    "Al Quds",
    "Ishbiliyah",
    "Al Khaleej",
    "Al Munsiyah",
    "Dhahrat Al Badi`ah",
    "Dhahrat Laban",
    "An Nasim Ash Sharqi",
    "Al Rabwah",
    "Tuwaiq",
    "Al-Nafal District",
    "Al-Faisaliah District",
    "Manfuha",
    "Al Mansouria",
  ],
  Jeddah: [
    "Al Hamdaniya District",
    "Al Zahra",
    "Al Bawadi",
    "Obhur Al-Shamaliyah",
    "Al Fayha`a",
  ],
  "Al Khobar": ["Al Bustan"],
  Dammam: ["Al Khalij", "Al Dabab"],
  Mubarraz: ["Al Khars"],
  Makkah: [
    "King Faisal bin Abdulaziz Road",
    "Walyal Ahd Dist.",
    "Al Naseem District",
  ],
  Jazan: ["Prince Sultan Road"],
  Madinah: ["Mazhour district"],
  Tabuk: ["Agricultural Area"],
};

const arCitiesRegions = {
  الرياض: [
    "العارض",
    "المرسلات",
    "الجزيرة",
    "الرحمانية",
    "القدس",
    "اشبيلية",
    "الخليج",
    "المونسية",
    "ظهرة البديعة",
    "ظهرة لبن",
    "النسيم الشرقي",
    "الربوة",
    "طويق",
    "حي النفل",
    "حي الفيصليه",
    "منفوحة",
    "المنصورية",
  ],
  جدة: ["حي الحمدانية", "الزهراء", "البوادي", "أبحر الشمالية", "الفيحاء"],
  الخبر: ["البستان"],
  الدمام: ["الخليج", "الضباب"],
  المبرز: ["الخرس"],
  مكة: ["طريق الملك فيصل بن عبد العزيز", "حي ولي العهد", "حي النسيم"],
  جازان: ["طريق الأمير سلطان"],
  "المدينة المنورة": ["حي مهزور"],
  تبوك: ["منطقة الزراعية"],
};

const customStyles = {
  clearIndicator: (base) => ({
    ...base,
    marginLeft: "-10px",
  }),
  control: (base) => ({
    ...base,
    borderRadius: "8px",

    boxShadow: "none",
    padding: "2px 8px",
    justifyContent: "space-between",
  }),
  singleValue: (base) => ({
    ...base,
    // textAlign: "right",
    fontWeight: "400",
    fontSize: "16px",
  }),
  menu: (base) => ({
    ...base,
    textAlign: "right",
    direction: "rtl",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    transform: "rotate(0deg)",
    marginLeft: "-10px",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 999999 }),
};
export { enCitiesRegions, arCitiesRegions, customStyles };
